import { api } from "@/lib/api";

// Push notifications for the phone app (the Capacitor app in Jemmz93/Jangle-app
// loads this site and exposes its native plugins on window.Capacitor). In a
// normal browser there is no window.Capacitor, so this does nothing.
export const PUSH_TOKEN_KEY = "jangle:push_token";

export function pushPlugin() {
  const cap = typeof window !== "undefined" ? window.Capacitor : null;
  if (!cap || !cap.isNativePlatform?.() || !cap.isPluginAvailable?.("PushNotifications")) return null;
  return cap.Plugins?.PushNotifications || null;
}

export function nativePlatform() {
  try { return window.Capacitor.getPlatform(); } catch { return "android"; }
}

// Called on sign-out so this phone stops getting the old account's alerts.
export async function forgetNativePushToken() {
  if (!pushPlugin()) return;
  let token = null;
  try { token = localStorage.getItem(PUSH_TOKEN_KEY); } catch { /* ignore */ }
  if (!token) return;
  try { await api.post("/me/push-token/remove", { token, platform: nativePlatform() }); } catch { /* ignore */ }
}
